import StaffManagementPeriodField from "./staff-management-period-field";
import StaffManagementQrField from "./staff-management-qr-field";
import StaffManagementStatusField from "./staff-management-status-field";
import StaffManagementSubcontractorsField from "./staff-management-subcontractors-field";
import StaffManagementWorkersField from "./staff-management-workers-field";
import StaffManagementEventLinkField from "./staff-management-event-link-field";
import StaffManagementCheckInQrField from "./staff-management-check-in-qr-field";
import StaffAttendanceGroupField from "./staff-attendance-group-field";
import StaffAttendanceStatusField from "./staff-attendance-status-field";
import StaffAttendanceWorkerRowField from "./staff-attendance-worker-row-field";
import StaffScanLocationMap from "./staff-scan-location-map";
import StaffScanLocationModal from "./staff-scan-location-modal";
import StaffCheckInHistoryDetailsModal from "./staff-check-in-history-details-modal";
import StaffAttendanceSessionDetailsField from "./staff-attendance-session-details-field";
import StaffAuditActionField from "./staff-audit-action-field";
import StaffAuditResultField from "./staff-audit-result-field";
import StaffAuditReasonField from "./staff-audit-reason-field";
import StaffAuditAccuracyField from "./staff-audit-accuracy-field";
import StaffAuditScanLocationField from "./staff-audit-scan-location-field";


const StaffManagementFields = {
    Period: StaffManagementPeriodField,
    Qr: StaffManagementQrField,
    Status: StaffManagementStatusField,
    Subcontractors: StaffManagementSubcontractorsField,
    Workers: StaffManagementWorkersField,
    EventLink: StaffManagementEventLinkField,
    CheckInQr: StaffManagementCheckInQrField,
    AttendanceGroup: StaffAttendanceGroupField,
    AttendanceStatus: StaffAttendanceStatusField,
    AttendanceWorkerRow: StaffAttendanceWorkerRowField,
    ScanLocationMap: StaffScanLocationMap,
    ScanLocationModal: StaffScanLocationModal,
    CheckInHistoryDetailsModal: StaffCheckInHistoryDetailsModal,
    AttendanceSessionDetails: StaffAttendanceSessionDetailsField,
    AuditAction: StaffAuditActionField,
    AuditResult: StaffAuditResultField,
    AuditReason: StaffAuditReasonField,
    AuditAccuracy: StaffAuditAccuracyField,
    AuditScanLocation: StaffAuditScanLocationField,
};

export default StaffManagementFields;
